import { IApplicationState } from '../../types/redux';

export const selectFreckles = (state: IApplicationState) => {
  return state.map.freckles;
};
